import { PayloadAction } from '@reduxjs/toolkit';
import { DTO__image_asset } from '@shared/dto/+image/image_asset_base/DTO__image_asset';
import { ENUM__redux_action } from '../../_base/ENUM__redux_action';
import { STATE__ui } from '../STATE__ui';

export const LOCAL__ui_drag_and_drop_set_image_dragged = (payload: DTO__image_asset = DTO__image_asset.CREATE_STUB()): PayloadAction<DTO__image_asset> => ({
  type: ENUM__redux_action.UI_DRAG_AND_DROP_SET_IMAGE_DRAGGED,
  payload,
});

export function INIT_LOCAL__ui_drag_and_drop_set_image_dragged(state: STATE__ui, action: PayloadAction<DTO__image_asset>) {
  let image_new = action.payload;
  let image_old = state.drag_and_drop__image_internal_dragged;

  if (image_old.is_stub() && image_new.is_stub()) return; //nothing to change
  if (image_new._id == image_old._id) return; //nothing to change

  state.drag_and_drop__image_internal_dragged = image_new.clone();
}
